<template>
  <div class="legal container">
    <div v-for="(item, index) in schoolDetail" :key="index" v-show="item.title == $route.query.title">
      <div>
        <h2>{{ item.title }}</h2>
        <h4>{{ item.text }}</h4>
        <div class="container">
          <img style="width: 100%; margin-top: 20px" :src="item.src1" alt />
        </div>
        <div class="container">
          <img :src="item.src2" alt style="width: 100%; margin: 20px auto" />
        </div>
        <div class="container">
          <img :src="item.src3" alt style="width: 100%; margin: 20px auto" />
        </div>
        <!-- 分割线 -->
        <div class="splitline"></div>
        <!-- 切换篇数 -->
        <div class="changepage">
          <p>
            上一篇：
            <span @click="tocaseDetail(titleList[1])">{{ titleList[1] }}</span>
          </p>
          <p>
            下一篇：
            <span @click="tocaseDetail(titleList[2])">{{ titleList[2] }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Casedetail',
  data() {
    return {
      schoolDetail: [
        {
          title: '巢湖学院',
          text: '安徽巢湖学院是安徽省属全日制公办本科高校。创建于1977年，前身是巢湖师范专科学校。2002年4月，经教育部批准，升格为本科院校，更名巢湖学院。2006年6月，获批学士学位授予权。2013年6月，顺利通过教育部本科教学工作合格评估。2018年12月，参与教育部本科教学工作审核评估，并获好评。2019年10月，获批硕士学位授予立项建设单位。学校占地面积1324.5亩。设有13个二级学院，59个本科专业，涵盖经济学、法学、教育学、文学、历史学、理学、工学、管理学、艺术学9大学科门类。现有教职工981人，其中具有副高以上职称307人，硕士以上学位849人，皖江学者特聘教授1人，省学术和技术带头人及后备人选4人，省级教学名师14人，省级教坛新秀36人。现有省级高水平教学团队15个，硕士研究生导师45人，双师双能型教师489人。全日制在校生17032人。',
          src1: require('../../assets/img/case/zhxy_image_0.png'),
        },
        {
          title: '上海工商职业技术学院',
          text: '上海工商职业技术学院（Shanghai Industrial and Commercial Polytechnic），前身为上海新侨职业技术学院，创建于1993年，由上海海外联谊会、上海市海外交流协会、上海市归国华侨联合会、上海中华职业教育社、上海市工商业联合会、中国民主建国会上海市委员会等六个统战系统的社会团体及民主党派共同举办的民办公益性高职院校，是上海市首批教育部批准独立设置、面向全国招生的民办全日制普通高等院校之一（1999年），也是市首批依法自主招生的高校之一（2005年）。2014年7月经上海市人民政府批复更改为现名。 学院有嘉定、青浦两个校区，占地总面积21.87万平方米；下设党政机构11个，直属机构3个，教学机构有：2个二级学院、6系1部；招生专业32个，已形成“以工为主、文商两翼”并举发展的“一体两翼”的专业发展布局。现全日制在校生约5800多名。学院在高职教育国际化特色、智慧型校园建设、产教融合、探索实践双元制教学模式，以及以职业生涯规划为导向的“四有”人才培养模式等方面取得显著成效。门禁管理系统通过管理软件实时反应所有人员进出信息、门状态信息和相关报警信息，保障学生宿舍的安全，通过指纹智能门锁，监控所有进出宿舍的人员。消费系统建设帮助学校实现无现金校园，节省了学校人力资源，方便了充值。',
          src1: require('../../assets/img/case/11.png'),
          src2: require('../../assets/img/case/99.png'),
          src3: require('../../assets/img/case/88.png'),
        },
        {
          title: '江苏省盐城技师学院',
          text: '学校创办于上世纪八十年代初期，1994年被国家劳动部评定为全国首批国家级重点技工学校，2007年经江苏省人民政府批准为全省首批副厅级重点技师学院，更名为“江苏省盐城技师学院”。2008年1月增挂江苏联合职业技术学院盐城技师分院校牌。2020年3月，盐城交通技师学院并入江苏省盐城技师学院。江苏省盐城技师学院创办于上世纪八十年代初期，设有八个二级学院。校内有600多名专职教师，拥有技师、高职、高技、中技办学层次，校企共建10个校内研究所，实习工位8000多个，年招生4000人左右，现有全日制在籍生1.4万多人。消费系统建设帮助学校实现无现金校园，节省了学校人力资源，方便了家长充值； 监控系统提升了校园安全管理的水平，为该校平安校园的建设坚定了可靠地基础',
          src1: require('../../assets/img/case/11.png'),
          src2: require('../../assets/img/case/66.png'),
        },
        {
          title: '盐城生物工程高等职业技术学校',
          text: '盐城生物工程高等职业技术学校（江苏联合职业技术学院盐城生物工程分院），是国家中等职业教育改革发展示范学校、江苏省现代化示范性职业学校、江苏省农业紧缺人才培训基地、江苏省退役士兵职业技能培训学院 学校前身为“江苏省盐城农业学校”，创办于1952年，1958年创办“江苏盐城农学院”，1961年江苏省农林厅批复为“盐城农业专科学校”，1975年经江苏省委同意建立“盐城地区五·七农业大学”，1978年经江苏省革委会决定恢复“江苏省盐城农业学校”。2004年4月升格为高等职业学校，更名为盐城生物工程高等职业技术学校、增挂江苏联合职业技术学院盐城生物工程分院校牌。据2019年6月学校官网显示，学校有亭湖南洋、建湖上冈2个校区，校园面积943亩，建筑面积16.3万平方米，设有8个系部，开设29个专业（五年制高职专业13个、三年制中职专业16个），有教职工520人，有全日制在校生6600余人。消费系统建设帮助学校实现无现金校园，节省了学校人力资源，方便了家长充值，远距离考勤系统的建设提高了校园人员考勤管理，提升了校园信息化建设水平。通道管理系统提高了校园安全管理水平，智慧能源管理水控系统，起到了节约水资源方便水资源合理控制。',
          src1: require('../../assets/img/case/11.png'),
          src2: require('../../assets/img/case/99.png'),
        },
        {
          title: '江苏省姜堰中学',
          text: '江苏省姜堰中学（Jiangyan High School of Jiangsu Province），国家级示范性高中、江苏省重点高中、江苏省四星级高中。江苏省姜堰中学创办于1939年，历经三水初级中学、泰县私立荣汉初级中学、存容学塾、苏中姜堰初级中学、泰县姜堰中学等的传承演变。1996年被省教委命名为江苏省姜堰中学。截至2015年，占地110亩，建筑面积54000多平方米。有高中班54个，学生3500余人，教职工307人。消费系统建设帮助学校实现无现金校园，节省了学校人力资源，方便了充值。通过车辆识别，对进出校园的人员进行识别。智慧图书馆实现了图书馆的智能化改造',
          src1: require('../../assets/img/case/11.png'),
          src2: require('../../assets/img/case/33.png'),
          src3: require('../../assets/img/case/100.png'),
        },
        {
          title: '江苏省丹阳高级中学',
          text: '江苏省丹阳高级中学（Danyang Senior High School of Jiangsu Province），简称“省丹中”，坐落于江苏省丹阳市，由丹阳市教育局举办，是首批国家级示范高中、江苏省首批四星级高中、江苏省首批重点中学、江苏省创新拔尖人才培养试点学校、江苏省首批高品质示范高中，南京大学创新人才培养战略合作伙伴、江苏省模范学校、全国教育系统先进集体。江苏省丹阳高级中学前身为国立社会教育学院附中，1941年建校于重庆青木关，1946年迁至江苏丹阳夫子庙，后几度易名，于1996年更名为江苏省丹阳高级中学。江苏省丹阳高级中学以“校风正、教风严、学风好、质量高”受到社会各界的广泛赞誉。学校向社会培养输送了数万名优秀毕业生，先后培养出周俊（中国科学院院士）、钱清泉（中国工程院院士）等英杰，获得了“全国实践教育活动先进单位”等一百多项国家级和省市荣誉。大门出入通道系统将先进的人脸识别技术及优秀的硬件设备集于一体，从而为校园管理中出现的不明人员混入。学校门口安装升降柱，能有效阻止车辆堵住学校大门，堵塞消防通道。消费系统建设帮助学校实现无现金校园，节省了学校人力资源，方便了充值。',
          src1: require('../../assets/img/case/99.png'),
          src2: require('../../assets/img/case/55.png'),
          src3: require('../../assets/img/case/88.png'),
          src4: require('../../assets/img/case/11.png'),
        },
        {
          title: '江苏省射阳中学',
          text: '江苏省射阳中学（Jiangsu Province Sheyang High School），简称“省射中”，位于江苏省射阳县新城区幸福大道28号。学校是首批国家级示范高中、首批江苏省四星级高中。江苏省射阳中学创办于1943年2月，最初校名为“盐东县立初级中学“，后几经更名。1956年夏，增设高中部，更名为“射阳县中学”。1998年7月，更名为“江苏省射阳中学”。截至2018年2月，江苏省射阳中学有3个年级、60个班级，在校学生近3000人，教职工317人，其中专职教师300人。消费系统建设帮助学校实现无现金校园，节省了学校人力资源，方便了家长充值，智慧电子班牌系统加强、方便学校教学统一管理，提高了学校智慧校园的水平，得到了学校一致认可。',
          src1: require('../../assets/img/case/11.png'),
          src2: require('../../assets/img/case/33.png'),
          src3: require('../../assets/img/case/44.png'),
        },
        {
          title: '兴洪中学',
          text: '兴洪中学创办于1994年6月，开苏北民办教育之先河，是宿迁市第一所民办学校。2006年1月，兴洪中学被江苏省教育厅评定为省重点中学，是泗洪县众多民办学校中唯一一家省重点中学。学校位于县城西郊，东邻省道徐宁路，西望宁宿徐高速公路，南面是正在崛起的泗洪工业园区，地理位置优越，交通便利，环境幽美。学校占地面积115亩，建筑面积36650平方米，校园绿化面积32216平方米。学校现有教学班级60个，在校学生3956人，专职教师168人。其中高级教师5人，省、市、县学科带头人10人，中教一级97人，研究生2人，本科学历占85%以上。兴洪中学创办于1994年6月，是泗洪县众多民办学校中唯一一家省重点中学。学校现有教学班级60个，在校学生3956人，专职教师168人。大门出入通道系统将先进的人脸识别技术及优秀的硬件设备集于一体，从而为校园管理中出现的不明人员混入。学校门口安装升降柱，能有效阻止车辆堵住学校大门，堵塞消防通道。。',
          src1: require('../../assets/img/case/33.png'),
          src2: require('../../assets/img/case/99.png'),
          src3: require('../../assets/img/case/55.png'),
        },
        {
          title: '江苏省阜宁中学',
          text: '江苏省阜宁中学（Jiangsu Funing Middle School），简称“阜中”，位于江苏省盐城市阜宁县。学校创办于1923年，1952年学校经江苏省教育厅批准正式定名为江苏省阜宁中学。2001年4月被江苏省教育厅确认为国家级示范高中，2004年3月转评为江苏省四星级高中。 截至2011年12月，江苏省阜宁中学有66个教学班，3358名学生， 在职教职工345人。消费系统建设帮助学校实现无现金校园，节省了学校人力资源，方便了家长充值；智慧电子班牌系统加强、方便学校教学统一管理，提高了学校智慧校园的水平，得到了学校一致认可。',
          src1: require('../../assets/img/case/11.png'),
          src2: require('../../assets/img/case/44.png'),
        },
        {
          title: '江苏省阜宁县实验初级中学',
          text: '阜宁县实验初级中学位于阜宁县城南新区。 校区占地228亩，总投资额1.68亿元，办学规模为20轨60个班。新校区交通便捷，设施齐全，环境幽雅，气势恢弘，堪称苏北一流的现代化校园。学校先后获得省绿色学校、省优秀教师群体、省和谐教育先进集体、省实施教育现代化工程示范初中、省初中物理学科实验基地先进集体、省初中英语学科实验基地先进集体、省“彩虹杯”初中生作文竞赛优秀组织奖、省中小学生“美好江苏”素质展示活动一等奖。阜宁县实验初级中学教育集团是以原阜宁县实验初级中学为龙头校，现有 108个教学班，6000余名学生，500多名教职工，办学规模全县最大。学校办学业绩显著，先后获得江苏省教育工作先进集体、江苏省平安校园、盐城市智慧校园等荣誉。消费系统建设帮助学校实现无现金校园，节省了学校人力资源，方便了家长充值；监控系统提升了校园安全管理的水平，为该校平安校园的建设坚定了可靠地基础',
          src1: require('../../assets/img/case/11.png'),
          src2: require('../../assets/img/case/99.png'),
          src3: require('../../assets/img/case/66.png'),
        },
        {
          title: '江苏省亭湖高级中学',
          text: '江苏省亭湖高级中学位于盐城市亭湖新区，亭湖大道北侧、兴洋大道东侧，与亭湖区政府隔街相望。2012年盐城市亭湖区政府在盐城市亭湖新区重点打造的民生工程，江苏省亭湖高级中学建成投入使用，盐城市景山中学高中部东迁到新校区，新校区建设“立足四星标准、留足五星空间”，最终打造成全省一流、面向现代化的高级中学。盐城市亭湖高级中学前身是盐城景山中学高中部，创办于2006年，2012年东迁到亭湖新区青年东路69号，定名为盐城市亭湖高级中学。是国家四星级高中；在校生数3000人。消费系统建设帮助学校实现无现金校园，节省了学校人力资源，方便了家长充值，远距离考勤系统的建设提高了校园人员考勤管理，提升了校园信息化建设水平。通道管理系统提高了校园安全管理水平，智慧宿舍管理系统，起到了节约水资源方便水资源合理控制。',
          src1: require('../../assets/img/case/11.png'),
          src2: require('../../assets/img/case/99.png'),
        },
        {
          title: '启东市折桂中学',
          text: '启东折桂中学位于启东市汇龙镇民乐中路580号，占地面积57168平方米（85.7亩），现有班级38个，教职工186人，在校学生总数2000多人。启东折桂中学于2004年在原江苏省启东中学初中部（民办）的基础上创办，2011年春改制为公办学校。2015年3月与江苏省启东中学剥离，正式单独办学。2012年起，政府投资1.419亿元原地重建，建筑总面积57638平方米。学校办学特色鲜明，坚持以人为本育人优先，注重通过丰富的学生活动，促进学生全面发展，特长发展。学校获得“南通市基础教育课程改革先进集体”“南通市工人先锋号”“南通市法治先进学校”， “江苏省健康促进学校（铜牌）”“南通市语言文字示范学校”“中小学德育工作测评启东市优秀学校”“南通市心理健康教育先进集体”等荣誉。学校注重艺术体育的培养，每年举办校园文化艺术节系列活动，通过艺术体育特长生的培训带动全校学生的艺术，体育素养的全面提高。学校代表队连续多年在启东市“三独比赛”、“中小学生田径运动会”等比赛中均居榜首，在南通市及省级比赛中也取得优异成绩。学校注重科技创新，培养创新人才，在省市科技创新大赛均取得优异成绩，先后获得“启东市科技创新大赛团体金奖”“江苏省青少年科技教育先进学校”等称号，并被授予“江苏省优秀少年科学院”，学校注重环境教育，培养师生环保理念，积极开展环保活动，先后被评为启东市，南通市“绿色学校”。 智慧餐盘消费系统建设帮助学校实现无现金校园，节省了学校人力资源，方便了家长充值；高端先进的就餐模式彰显了学校智慧校园的先进水平，访客系统为学校访客进出管理实现了智能化精准管理，为学校平安校园的建设增添了保障。 ',
          src1: require('../../assets/img/case/11.png'),
        },
        {
          title: '南通市通州区育才中学',
          text: '南通市通州区育才中学位于江苏省南通市通州区金沙镇，原系江苏省通州高级中学的初中部。2000年经南通市教育局批准为全日制民办中学，2006年8月搬迁南通高新技术产业开发区银河路21号独立办学，2010年下半年学校“回归公办”。 2014年9月，学校搬迁至新校区。学校现为全国“百强特色学校”、南通市文明单位、南通市首批教师专业发展优质学校、南通市政治学科基地、南通市“青少年行为规范示范学校”。由学校部分师生自编、自导、自演和自行制作的校园青春故事片《我叫张晓波》荣获第五届全国中小学校园电视和优秀节目评比金奖。南通市通州区育才中学原系国家级示范性高中、省模范学校。学校现有48个教学班，在校学生3000余人，在编教职员工218人。消费系统建设帮助学校实现无现金校园，节省了学校人力资源，方便了家长充值，远距离考勤系统的建设提高了校园人员考勤管理，提升了校园信息化建设水平。',
          src1: require('../../assets/img/case/11.png'),
          src2: require('../../assets/img/case/99.png'),
        },
        {
          title: '江苏省南通田家炳中学',
          text: '江苏省南通田家炳中学（Nantong Tianjiabing Middle School of Jiangsu Province）位于江苏省南通市，学校是由南通市教育局举办的一所公办初级中学。学校始建于1952年，时名苏北工人技术学校。1954年，更名为“南通市第一初级中学”。 1958年，更名为南通市第三中学。2002年，增挂“南通市田家炳实验中学”校牌。2014年4月，更名为江苏省南通田家炳中学。截至2016年3月，学校本部占地近90亩，建筑总面积33755平方米，固定资产总额5700余万元，藏书15万册。南通市学田中学（东校区）占地26亩，建筑总面积16996平方米，总投资3000万元；有教学班级90个，学生5500余人，教职工400余人。消费系统建设帮助学校实现无现金校园，节省了学校人力资源，方便了家长充值； 录播系统完成了教师、学生的视频采集自动跟踪音频智能采集，教师电脑屏幕截取，教师/学生视频/计算机画面智能导播，自动传送至课件实时录制系统生成优质的精品课程，同时通过课堂直播系统在局域网、互联网上直播为远端用户提供在线实时学习的平台',
          src1: require('../../assets/img/case/11.png'),
          src2: require('../../assets/img/case/88.png'),
        },
        {
          title: '江苏省阜宁中等专业学校',
          text: '江苏省阜宁中等专业学校学校位于江苏省盐城市阜宁县，学校先后获得了全国德育管理先进学校、全国劳动力转移培训先进单位、江苏省职业教育先进单位、江苏省诚信办学规范管理示范学校、盐城市依法治校先进学校、盐城市教育工作改革创新先进单位、盐城市技能大赛先进单位、阜宁县综合先进单位等多项荣誉。学校正瞄准创建国家级高水平示范性职业学校的目标，启动新校区建设工程，精心打造职教品牌，着力提升服务经济社会发展、服务人民群众的水平，实现学校的跨越发展。江苏省阜宁中等专业学校现为国家级重点中等职业学校、江苏省四星级中等职业学校、江苏省高水平示范性职业学校、江苏省课程改革实验学校。目前，学校现有教职工250多人，中职在籍生5000多人，消费系统建设帮助学校实现无现金校园，节省了学校人力资源，方便了家长充值；监控系统提升了校园安全管理的水平，为该校平安校园的建设坚定了可靠地基础',
          src1: require('../../assets/img/case/66.png'),
          src2: require('../../assets/img/case/33.png'),
          src3: require('../../assets/img/case/11.png'),
        },
        {
          title: '盐城市第一中学',
          text: '盐城市第一中学，始建于1923年，初名“盐城县立初级中学”，由陈毅委托著名革命教育家赵敬之创立，是盐城地区第一所公立中学，1990年，首批通过江苏省重点高中评估验收；2001年，通过国家级示范性高中评估验收；2003年11月，顺利转评为江苏省首批四星级高中。学校占地面积280亩，建筑面积10.55万平方米，在校学生4000余人，专任教师351人。学校有多名学生参加全国和省级数学、物理等学科竞赛获多次一等奖，有很多优秀学子进入清华大学、北京大学等著名高等学府深造。消费系统建设帮助学校实现无现金校园，节省了学校人力资源，方便了充值。通过车辆识别，对进出校园的人员进行识别。',
          src1: require('../../assets/img/case/11.png'),
          src2: require('../../assets/img/case/22.png'),
          src3: require('../../assets/img/case/33.png'),
        },
        {
          title: '海陵中学',
          text: '海陵中学是由江苏省海安高级中学参与举办的一所股份制民办学校，也称海中分校。现已于2011年正式成为国家公办学校。学校具有丰厚的办学底蕴。历史名校、国家级示范高中——海安高级中学，教学业绩蜚声省内外，曾培育了多名全省高考状元和国际中学生奥赛金牌得主，高考高分段人数连续五年列全省之首。由它创办的海中附校，以“活动育人”为特色，全面推进素质教育，中考升学率、重点中学录取率在全县遥遥领先，各学科竞赛获奖人数在南通市名列前茅，年年都被县教育局评为“教育教学质量优等学校”。海安县海陵中学是一所县直属公立全日制普通初级中学。现有3800多名师生，创办以来学校先后获得 “江苏省最具影响力初中”“江苏省初中教学管理创新特色学校”“ “江苏省平安校园”“南通市文明校园”等综合荣誉消费系统建设帮助学校实现无现金校园，节省了学校人力资源，方便了家长充值；能源管理系统提升了校园资源智能管理的水平，为学校水、电管理提供了先进工具，减少了资源浪费，节省了资源成本。',
          src1: require('../../assets/img/case/11.png'),
        },
        {
          title: '连云港东港中学',
          text: '连云港市东港中学创建于1989年，每年约有初中教学班的40个，在校学生1700多人，教职工约150人，其中中学高级教师约20人、中学一级教师约70人。消费系统建设帮助学校实现无现金校园，节省了学校人力资源，方便了家长充值，微应用考勤系统的建设提高了校园人员考勤管理，提升了校园信息化建设水平。。',
          src1: require('../../assets/img/case/11.png'),
          src2: require('../../assets/img/case/22.png'),
        },
        {
          title: '睢宁县菁华高级中学',
          text: '睢宁县菁华高级中学（Suining Jinghua Senior High School）建立于2001年，占地135亩，建筑面积约7万平米，设备设施先进，环境优美，风格独特。学校拥有专职教师170余名，其中，市县级学科带头人15人，高级以上职称34人，在校学生近3000人。校园电视台系统的建立促进了学生自主探索、创新学习的能力，开阔了学生的视野，对学校重大活动、事件进行记录宣传、展现校园风貌，可与校外媒体渠道对接，进行网络直播。。',
          src1: require('../../assets/img/case/11.png'),
          src2: require('../../assets/img/case/77.png'),
        },
        {
          title: '社区电瓶车智能充电桩',
          text: '近年来，由于新能源技术的推广应用和环境保护力度的不断加大，方便快捷的电动自行车越来越受到广大市民的青睞。我国现有电动自行车保有量在 3 亿辆左右，并且以每年 30%的速度快速增长。随着电动自行车数量的快速增长，由于其充电形式不规律、充电频繁、充电环境差等原因造成的电气火灾数量也急剧上升。电动自行车的集中存放和充电，也容易引发连片火灾。根据消防部门的调查发现，许多居民小区的电气火灾都是由于电动自行车充电所引发的。电动自行车充电之所以容易引起火灾，其根本原因与其充电环境、使用习惯和自质有关。几乎所有电动车使用的装饰性部件，使用的都是氧指数在 17~18 的易燃材质，这类材料只需要很少的氧气就能迅速起火蔓延。这些装饰性部件还大量使用高分子材料。',
        },
        {
          title: '建行无人值守无感支付停车',
          text: '近年来，由于新能源技术的推广应用和环境保护力度的不断加大，方便快捷的电动自行车越来越受到广大市民的青睞。我国现有电动自行车保有量在 3 亿辆左右，并且以每年 30%的速度快速增长。随着电动自行车数量的快速增长，由于其充电形式不规律、充电频繁、充电环境差等原因造成的电气火灾数量也急剧上升。电动自行车的集中存放和充电，也容易引发连片火灾。根据消防部门的调查发现，许多居民小区的电气火灾都是由于电动自行车充电所引发的。电动自行车充电之所以容易引起火灾，其根本原因与其充电环境、使用习惯和自质有关。几乎所有电动车使用的装饰性部件，使用的都是氧指数在 17~18 的易燃材质，这类材料只需要很少的氧气就能迅速起火蔓延。这些装饰性部件还大量使用高分子材料。',
        },
        {
          title: '智慧工地项目',
          text: '基于智慧工地物联网云平台与现场多个子系统的互联，实现现场各类工况数据采集、存储、分析与应用。通过接入智慧工地物联网云平台的多个子系统板块，根据现场管理实际需求灵活组合，实现一体化、模块化、智能化、网络化的施工现场过程全面感知、协同工作、智能分析、风险预控、知识共享、互联互通等业务，全面满足建筑施工企业精细化管理的业务需求，智能化地辅助建筑施工企业进行科学决策，促进施工企业监管水平的全面提高。',
          src1: require('../../assets/img/case/zhgd11.png'),
        },
        {
          title: '韩城全域旅游项目',
          text: '陕西省韩城全域旅游主要将6大村子，司马迁祠、明清古城、党家村、梁带村国家遗址公园、文庙、黄河湿地等人文历史与自然景观的完美结合、将各产业、各行业的深度融合打造“关中水乡、宜居韩城”。',
          src1: require('../../assets/img/case/zhjq11_image.png'),
        },
        {
          title: '黄陵全域旅游项目',
          text: '黄陵县推行“旅游+N”模式，提升黄陵全域旅游的品牌效应，推动黄陵旅游从“一日游”向“多日游”、“过境地”向“目的地”转变，加快了旅游产业转型升级。',
          src1: require('../../assets/img/case/zhjq12_image.png'),
        },
        {
          title: '万泉湖智慧旅游项目',
          text: '万泉湖风村子位于林州市南部的淇、淅河交汇处。是国家AAAA级民俗村，这里有淇淅河国家湿地公园，有豫北最大的涌泉群——石门涌泉。 大小泉眼数不胜数，生生不息，汇流成了一条波光粼粼的泱泱湖泊——故名万泉湖，万泉湖风村子数字化项目的建成，对村子管理和服务能力提升，以及对万泉湖对自然风景的保护，都起到良好的促进作用。',
          src1: require('../../assets/img/case/zhjq13_image.png'),
        },
      ],
      titleList: ['', '', ''],
    };
  },
  mounted() {
    this.getTitle();
  },
  watch: {
    $route() {
      this.getTitle();
    },
  },
  methods: {
    getTitle() {
      this.schoolDetail.map((value, index) => {
        if (value.title == this.$route.query.title) {
          if (index == 0) {
            this.$set(this.titleList, 1, '暂无信息');
            this.$set(this.titleList, 2, this.schoolDetail[index + 1].title);
          } else if (index == this.schoolDetail.length) {
            this.$set(this.titleList, 1, this.schoolDetail[index - 1].title);
            this.$set(this.titleList, 2, '暂无信息');
          } else {
            this.$set(this.titleList, 1, this.schoolDetail[index - 1].title);
            this.$set(this.titleList, 2, this.schoolDetail[index + 1].title);
          }
        }
      });
    },
    tocaseDetail(title) {
      if (title == '暂无信息') {
        return;
      }
      let query = {
        title: title,
      };
      this.$router.push({ path: '/case/casedetail', query });
    },
  },
};
</script>
<style scoped>
.legal {
  margin-bottom: 100px;
}
.container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.legal h2 {
  margin: 100px;
  text-align: center;
  font-size: 48px;
  color: #333;
  font-weight: bold;
}
.legal h4 {
  font-size: 18px;
  font-weight: 400;
  text-indent: 2em;
  line-height: 1.7;
  color: #666;
}
.splitline {
  margin-top: 41px;
  width: 1200px;
  height: 1px;
  background-color: #cccccc;
}
.changepage {
  margin-top: 40px;
  font-size: 18px;
  font-weight: 400;
  color: #666;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
</style>
